module.exports = __webpack_public_path__ + "static/image-laptop-tech-babb8fdbb450c40ac9aadddff3a37e14.png";